export enum LicenseGaugeStatus {
  OK,
  WARNING,
  ERROR,
}
